import { render, staticRenderFns } from "./TagInfo.vue?vue&type=template&id=1858ce19"
import script from "./TagInfo.vue?vue&type=script&lang=js"
export * from "./TagInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports